export default {
    modules: {
        deviceMonitor: 'Device Monitor',
        monitoringPoint: 'Asset',
        Map: 'Map',
        incubator: 'Incubator',
        fridge: 'Refrigerator',
        car: 'Refrigerated Truck',
        refrigeratory: 'Cold Storage',
        detailData: 'Data Details',
        ex: 'Abnormal',
        exReason: 'Abnormal Causes',
        sensor: 'Sensor',
        gateway: 'Gateway',
        display: 'Show Label',
        relay: 'Repeater',
        base: 'Bracket',
        scene: 'Bracket',
        proberange: 'Monitoring Range',
        alarmRecord: 'Alarm Records',
        collectRecord: 'Sampling Record',
        workOrder: 'Work Order',
        contact: 'Contact',
        download: 'Download',
        noticelog: 'Notice Log',
        sysLog: 'System Log',
        alarmLog: 'Alarm Toggle Log',
        user: 'User Count',
        role: 'Role',
        customer: 'Company',
        probeunit: 'Measurement Unit',
        forwarding: 'Forwarding Settings',
        param: 'Parameters',
        carrierType: 'Asset Type',
        monitorTask: 'Detection Task',
        deviceType: 'Device Type',
        deviceTransfer: 'Device Loan',
        resource: 'Resource',
        warehouse: 'Warehouse',
        overview: 'Overview',
        store: 'Store',
        exportTask: 'Export Task',
        statistic: 'Statistics',
        invalidRule: 'Invalid Rule',
        gas: 'Gas',
        magnetism: 'Door Sensor',
        verificationTask: 'Verification Task',
        onlineHelp: 'Online Help Settings',


    }
};
